var React = require('react');

function RotateIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#2F3641","fillRule":"evenodd","d":"M8,0 C6.19193153,0 4.51977493,0.60651422 3.17708333,1.62239587 L1.6002604,0.06640625 L0,6.66666667 L6.6002604,5 L4.62239587,3.0494792 C5.5839244,2.39143947 6.741644,2 8,2 C11.325562,2 14,4.674438 14,8 C14,11.325562 11.325562,14 8,14 C5.88283427,14 4.0347854,12.9109587 2.96484373,11.2643227 L1.2877604,12.3541667 C2.71381873,14.5488647 5.19449907,16 8,16 C12.406438,16 16,12.406438 16,8 C16,3.593562 12.406438,0 8,0 Z","transform":"translate(4 4)"}));
}

RotateIcon.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = RotateIcon;

RotateIcon.default = RotateIcon;
